import { render } from "./BookTable.vue?vue&type=template&id=673d30f0&scoped=true"
import script from "./BookTable.vue?vue&type=script&lang=js"
export * from "./BookTable.vue?vue&type=script&lang=js"

import "./BookTable.vue?vue&type=style&index=0&id=673d30f0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673d30f0"]])

export default __exports__